var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendarFrame",staticClass:"calendar"},_vm._l((_vm.calendarMonths),function(m,index){return _c('CalendarMonth',{key:index,attrs:{"month":m,"selected-date":_vm.selectedDate,"handle-select-date":_vm.handleSelectDate}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }